require("./utilities/objectAssign.js");
import "sharer.js";

import Window from "./stores/Window.js";
import Emitter from "./utilities/Emitter.js";
import Dropdowns from "./components/Dropdowns.js";
import PublicationCard from "./components/PublicationCard.js";
import StaticSlider from "./components/StaticSlider.js";
import Anchor from "./global/Anchor.js";
import ImageComparison from "./components/ImageComparison.js";
import SwiperMobile from "./components/SwiperMobile.js";
import Navigation from "./components/Navigation.js";
import MasoneryFilter from "./components/MasoneryFilter.js";
import RealisationFilter from "./components/RealisationFilter.js";
// import Cookies from "./components/Cookies.js";

const components = [
  { el: ".js-dropdowns", component: Dropdowns },
  { el: ".js-publication-card", component: PublicationCard },
  { el: ".js-image-comparison", component: ImageComparison },
  { el: ".js-slider-realisations", component: StaticSlider },
  { el: ".js-slider-missions", component: StaticSlider },
  { el: ".js-navigation", component: Navigation },
  { el: ".swiper-container", component: SwiperMobile },
  { el: ".js-anchor", component: Anchor },
  { el: ".js-masonery-filter", component: MasoneryFilter },
  { el: ".js-realisation-filter", component: RealisationFilter },
  // { el: ".js-cookies", component: Cookies },
];

class App {
  constructor() {
    this._components = [];

    window.addEventListener("resize", this.resize, false);
    window.addEventListener("scroll", this.scroll, false);

    this._update = this.update.bind(this);

    this.update();

    this.createComponents(components);
  }

  createComponents(components) {
    for (let i = 0, l = components.length; i < l; i++) {
      let elements = document.querySelectorAll(components[i].el);

      Array.prototype.forEach.call(elements, (el) => {
        let params = { $el: el };
        if (!!components[i].params) Object.assign(params, components[i].params);

        const view = new components[i].component(params);

        this._components.push(view);
      });
    }
  }

  update() {
    Emitter.emit("update");
    requestAnimationFrame(this._update);
  }

  resize() {
    Emitter.emit("resize");
  }

  scroll() {
    Emitter.emit("scroll");
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new App();
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js